import { BrowserRouter, Navigate, useNavigate } from "react-router-dom";
import AppRouter from "./routing/AppRouter";
import { ThemeProvider } from "@mui/material/styles";
import theme from "themes";
import { ModalProvider } from "context/modalContext";
import { QubBringValueProvider } from "context/bringValueContext";
import { GenApiAxiosInterceptor } from "api/axiosInstance";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/authReducer";
import "./explorer.css";

function App() {
  // const { isLoggedIn } = useSelector((state) => state.auth);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     const lastCounter = localStorage.getItem("counter");
  //     localStorage.setItem("counter", lastCounter - 1);
  //     if (lastCounter - 1 === 0) localStorage.setItem("lastClose", Date.now());
  //   };

  //   const counter = localStorage.getItem("counter") || 0;
  //   //
  //   localStorage.setItem("counter", parseInt(counter) + 1);

  //   if (localStorage.getItem("lastClose") !== null) {
  //     if (Date.now() - localStorage.getItem("lastClose") > 3000) {
  //       console.log("I will clear!!");
  //       localStorage.clear();
  //       dispatch(logout());
  //     }
  //   } else {
  //     console.log("hey", counter);
  //   }
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);
  return (
    <QubBringValueProvider>
      <ThemeProvider theme={theme()}>
        <ModalProvider>
          <GenApiAxiosInterceptor>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </GenApiAxiosInterceptor>
        </ModalProvider>
      </ThemeProvider>
    </QubBringValueProvider>
  );
}

export default App;
